import sanitizeHtml from 'sanitize-html';
const sanitize = (dirty = '') => {
    let options = {
        allowedTags: [ 'b', 'i', 'em', 'strong', 'a', 'img' ],
        allowedAttributes: {
            'a': [ 'href' ],
            'img': ['src', 'style', 'class']
        },
        allowedSchemes: [ 'data', 'http', 'https', 'blob'],
        allowedIframeHostnames: ['www.youtube.com']
    };
    return sanitizeHtml(dirty, options);
}

export default sanitize;
